// src/utils/classReports.js

/**
 * Fetch a base64 PDF from your API and download it using the server-provided filename.
 * @param {object} opts
 * @param {string} opts.report - "<FUND+REPORT>" string
 * @param {object} opts.api - API client that has .reports(report)
 * @param {string} [opts.fallbackName='report.pdf'] - used if API doesn't return a filename
 */
export async function downloadReport({ report, api, fallbackName = 'report.pdf' }) {
  if (!api?.reports) throw new Error('Invalid api client passed to downloadReport');

  const { data } = await api.reports(report);

  let b64 = data?.base64;
  if (!b64) throw new Error('No base64 found in response');

  // normalize
  b64 = b64.replace(/\s/g, '').replace(/^data:application\/pdf;base64,/, '');

  // base64 -> bytes
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i) & 0xff;

  // bytes -> blob url
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  // safe filename
  const fname = (data.filename || fallbackName).replace(/[^\w.\-()\s]/g, '_');

  // trigger download
  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', fname);
  document.body.appendChild(a);
  a.click();
  a.remove();

  // cleanup
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
